import {createContext} from "react";
import {AuthInterface} from "../services/model";

export default createContext({} as AuthInterface)